import { z } from 'zod';

export const exportCreditAdviceSchema = z.object({
  ma_ngv: z.string().default('1'),
  dia_chi: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  ngay_ct: z.string().optional(),
  dien_giai: z.string().optional(),
  ngay_lct: z.string().optional(),
  ngay_ct0: z.string().optional().nullable(),
  ma_nt: z.string().optional(),
  ty_gia: z.coerce.number().optional(),

  transfer_yn: z.boolean().optional(),
  status: z.string().optional()
});

export type ExportCreditAdviceFormValues = z.infer<typeof exportCreditAdviceSchema>;

export const initialFormValues: ExportCreditAdviceFormValues = {
  ma_ngv: '1',
  dia_chi: '',
  dien_giai: '',
  ma_nt: '',
  ong_ba: '',
  ngay_lct: new Date().toISOString().split('T')[0],
  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_ct0: new Date().toISOString().split('T')[0],
  ty_gia: 1,
  status: '0',
  transfer_yn: false
};

export const searchSchema = z.object({
  ma_ngv: z.string().optional(),
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  tk: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_kh: z.string().optional(),
  tk_co: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ma_ngv: '',
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  tk: '',
  dien_giai: '',
  ma_kh: '',
  tk_co: '',
  ma_unit: '',
  status: '',
  user_id0: ''
};
